import './ForgotPassword.scss'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { emailLoginPattern } from '@utils/helpers'
import { Header } from '@components/Header/Header'
import DotSpinner from '@components/DotSpinner/DotSpinner'
import { LoginInputField } from '@components/Login/LoginInputField/LoginInputField'
import ForgotPasswordInputSublabel from '@templates/ForgotPasswordInputSublabel/ForgotPasswordInputSublabel'
import { SecondaryButton } from '@components/Buttons/SecondaryButton/SecondaryButton'
import { VelvetSDK } from 'sdk'
import useGoBackNavigation from '@hooks/useGoBackNavigation'

type ForgotPasswordProps = {
  showMenu: (status: boolean) => void
}

export const ForgotPassword = ({ showMenu }: ForgotPasswordProps) => {
  const [resetPasswordEmail, setResetPasswordEmail] = useState('')
  const [emailErrorMessage, setEmailErrorMessage] = useState<string | null>(null)
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const navigate = useNavigate()
  const V = VelvetSDK.Vocabulary.vocabulary
  const resetPasswordLabel = V?.forgotDescriptionLabel
  const forgotPasswordSublabel = !isFormSubmitted ? (
    resetPasswordLabel
  ) : (
    <ForgotPasswordInputSublabel email={resetPasswordEmail} />
  )

  useGoBackNavigation()

  useEffect(() => {
    showMenu(false)

    return () => {
      showMenu(true)
    }
  }, [showMenu])

  const handleSendResetPasswordEmail = () => {
    setLoading(true)

    VelvetSDK.Authentication.service
      .resetPassword(resetPasswordEmail)
      ?.then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const checkEmail = (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()

    if (emailLoginPattern.test(resetPasswordEmail)) {
      setEmailErrorMessage(null)
      handleSendResetPasswordEmail()
      setIsFormSubmitted(true)
    } else {
      setEmailErrorMessage(V?.errorEmailFormat)
    }
  }

  const handleResetPasswordEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    setResetPasswordEmail(e.target.value)
  }

  const navigateBack = useCallback(() => {
    navigate(-1)
  }, [navigate])

  return (
    <div className="forgot-password">
      <Header label="LogIn" />
      {loading ? (
        <DotSpinner />
      ) : (
        <>
          <div className="forgot-password_container">
            <LoginInputField
              type="text"
              label={V?.forgotPasswordTitle}
              sublabel={forgotPasswordSublabel}
              inputValue={resetPasswordEmail}
              errorMessage={emailErrorMessage}
              isSubmitted={isFormSubmitted}
              onChange={handleResetPasswordEmail}
              onSubmit={checkEmail}
              inputRef={inputRef}
              placeholder={V?.createAccountEmailPlaceholder}
            />
          </div>
          {!isFormSubmitted && (
            <div className="forgot-password_buttons">
              <SecondaryButton onClick={navigateBack}>{V?.backButtonLabel}</SecondaryButton>
              <SecondaryButton onClick={checkEmail}>{V?.sendButtonLabel}</SecondaryButton>
            </div>
          )}
        </>
      )}
    </div>
  )
}
